export default {
  403: 'You are unauthorized to view this page',
  503: 'Currently service is disabled, please try again later or contact the support'
}



// WEBPACK FOOTER //
// ./src/helpers/errorMessages.js